import React, {PureComponent} from 'react';

import {Classes, Overlay} from "@blueprintjs/core";

export default class WindowExpiredModal extends PureComponent {
    state = {

        testNumber: ''
    }
    handleClose = () => {
        this.setState({
            overlayIsOpen: false
        })
    }

    componentDidMount() {
        this.setState({
            overlayIsOpen: this.props.showModal,
        })
    }

    componentDidUpdate() {
        if (this.state.overlayIsOpen !== this.props.showModal) {
            this.setState({
                overlayIsOpen: this.props.showModal
            })
        }
    }

    setTestNumber = (e) => {
        this.setState({testNumber: e.target.value})
    }

    render() {
        return (
            <Overlay
                onClose={this.props.handleClose} className={Classes.OVERLAY_SCROLL_CONTAINER}
                isOpen={this.state.overlayIsOpen}
                style={{
                    display: 'flex',
                    flex: 1,
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                <div className="modal-field"
                     style={{width: this.props.width || '60%', maxWidth: this.props.maxWidth || '100%'}}>
                    <div className="onboarding-panel viber-modal-container">
                        <p className=" modal-title text-center m-m-b" style={{fontSize: "30px"}}>
                            Sent to:
                        </p>
                        <div className="separator "></div>

                        <div className="section-content text-center">
                            <p className="letter text-bold window-sent-to">

                                {this.props.sentTo}

                                <span>Subscribers</span>
                            </p>
                            <div className='info-message m-m-t text-center'>
                                <span className='fas fa-exclamation-triangle'></span>
                                <p>Looks like 24 hour window for some of your Facebook subscribers
                                    is out and the post was
                                    not sent to them. </p>
                                <p>
                                    Please check <span>“Sent”</span> stats for this post in <span>Campaign Performance</span>. For further
                                    instructions please contact support.
                                </p>
                            </div>
                        </div>

                        <div className=" flex-middle m-m-t">
                            <button
                                className="btn-lite dist-platf-button"
                                disabled={false}
                                onClick={() => {
                                    this.props.handleClose()
                                }}>
                                Close
                            </button>

                        </div>
                    </div>
                </div>
            </Overlay>
        )
    }
}